import { createBrowserClient } from "@supabase/ssr";

function makeClient() {
  return createBrowserClient(process.env.NEXT_PUBLIC_SUPABASE_URL!, process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY!);
}

/**
 * Singleton browser Supabase client. `@supabase/ssr` requires exactly ONE browser client
 * per tab: every `createBrowserClient` call builds a fresh `GoTrueClient` that registers the
 * same named `navigator.locks` auth-token lock and an auto-refresh timer. Multiple instances
 * contend on that lock and busy-spin (`LockManager.request` every frame), leaking client
 * instances until the tab OOM-crashes. Memoizing also gives callers a stable reference, so
 * hooks that depend on the client (e.g. `useUser`) don't re-fire effects on every render.
 * Typed off `makeClient`'s call-inferred return so the client type matches every call site.
 */
let browserClient: ReturnType<typeof makeClient> | undefined;

/**
 * Returns the shared browser Supabase client, creating it on first call.
 *
 * @returns The singleton authenticated-role browser Supabase client.
 */
export function createClient() {
  if (!browserClient) browserClient = makeClient();
  return browserClient;
}
